import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppFloat from '@/components/feature/WhatsAppFloat';
import PageSEO from '@/components/base/PageSEO';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import FeaturedProjects from './components/FeaturedProjects';
import AboutSunshine from './components/AboutSunshine';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import InvestmentSection from './components/InvestmentSection';
import HowWeWork from './components/HowWeWork';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

const SITE_URL = import.meta.env.VITE_SITE_URL || '';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="relative">
      <PageSEO
        title="Sunshine Real Estate Marketing SMC (Pvt.) Ltd. — Premium Property Investment Pakistan"
        description="Sunshine Real Estate Marketing SMC (Pvt.) Ltd. is Pakistan's trusted property investment partner. Verified projects, residential plots, commercial opportunities, expert consultation in Islamabad. WhatsApp +92 334 8872555"
        keywords="Sunshine Real Estate, Pakistan property investment, Islamabad plots, real estate marketing, residential plots Islamabad, commercial property Pakistan, Margala Garden Housing Society"
        canonicalPath="/"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'RealEstateAgent',
            name: 'Sunshine Real Estate Marketing SMC (Pvt.) Ltd.',
            url: SITE_URL,
            telephone: '+92 334 8872555',
            areaServed: 'Islamabad, Pakistan',
            description: 'Premium real estate investment and property marketing company in Pakistan — trusted since 2019.',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Islamabad',
              addressCountry: 'PK',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: '33.6844',
              longitude: '73.0479',
            },
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                opens: '09:00',
                closes: '19:00',
              },
            ],
            sameAs: [
              `https://wa.me/923348872555`,
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Sunshine Real Estate — Premium Property Investment Pakistan',
            description: "Sunshine Real Estate Marketing SMC (Pvt.) Ltd. is Pakistan's trusted property investment partner. Verified projects, residential plots, commercial opportunities, expert consultation in Islamabad.",
            url: SITE_URL,
            isPartOf: {
              '@type': 'WebSite',
              name: 'Sunshine Real Estate Marketing SMC (Pvt.) Ltd.',
              url: SITE_URL,
            },
          },
        ]}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <FeaturedProjects />
        <AboutSunshine />
        <WhyChooseUs />
        <Services />
        <InvestmentSection />
        <HowWeWork />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}